import request from '@/utils/service';
/**
 * @returns {*}
 */
export function auth(app_id, redirect_uri) {
  return request({
    url: '/auth2.0/authorize?app_id='+app_id+'&redirect_uri='+redirect_uri+'&scope=base_info%2Cauth_user',
    method: 'get'
  });
}

/**
 * @returns {*}
 */
export function getToken(code, app_id, sign, time, uuid) {
  return request({
    url: '/auth2.0/token?grant_type=authorization_code'+'&code='+code+'&app_id='+app_id+'&sign='+sign+'&time='+time+'&uuid='+uuid,
    method: 'post'
  });
}

/**
 * @returns {*}
 */
export function getUserBaseInfo(auth_token, app_id, sign, time, uuid) {
  return request({
    url: '/auth2.0/get_base_info?auth_token='+auth_token+'&app_id='+app_id+'&sign='+sign+'&time='+time+'&uuid='+uuid,
    method: 'get'
  });
}